import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-assistance',
  templateUrl: './info-assistance.component.html',
  styleUrls: ['./info-assistance.component.scss'],
})
export class InfoAssistanceComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
